// Synchronous function for immediate initialization
const getInitialLanguage = (): string => {
  if (typeof window === 'undefined') return 'en'; // SSR support

  // Only check LocalStorage for initial load
  const stored = localStorage.getItem('lang');
  if (stored) {
    return stored;
  }

  // Fallback to English (detectLanguage will run async)
  return 'en';
};

export default getInitialLanguage;